import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import RegisterBackground from './RegisterBackground';
import PublicHeader from './PublicHeader';
import PublicSidebar from './PublicSidebar';
import Footer from './Footer';
import { Box, Toolbar } from '@mui/material';

interface RegisterLayoutProps {
  children: React.ReactNode;
}

const RegisterLayout: React.FC<RegisterLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Sync i18n with user locale on mount and user change
  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  return (
    <RegisterBackground>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <PublicHeader onDrawerToggle={handleDrawerToggle} />
        <PublicSidebar mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />
        <Toolbar /> {/* Spacer для fixed AppBar */}

        {/* Main content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', lg: 'flex-start' },
            px: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              my: 'auto',
              width: '100%',
              maxWidth: { xs: '100%', sm: '450px', md: '500px', lg: '550px' },
              minWidth: { xs: 'auto', sm: '400px' },
              ml: { lg: '25%' },
              transform: { lg: 'translateX(-50%)' },
            }}
          >
            {children}
          </Box>
        </Box>

        <Footer />
      </Box>
    </RegisterBackground>
  );
};

export default RegisterLayout;